import { render, staticRenderFns } from "./fryer-polaris-3-packing-page.vue?vue&type=template&id=17762694"
import script from "./fryer-polaris-3-packing-page.vue?vue&type=script&lang=js"
export * from "./fryer-polaris-3-packing-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports